import { escapeHtml, localDateValue } from "./booking-utils";

export interface BookingCalendarCellsInput {
  visibleMonth: Date;
  today: string;
  selectedDate?: string;
  availabilityDays: ReadonlyMap<string, number>;
  locale: string;
}

export function renderCalendarMonthOptions(visibleMonth: Date, locale: string): string {
  const monthFormatter = new Intl.DateTimeFormat(locale, { month: "long" });
  return Array.from({ length: 12 }, (_, index) => `<option value="${index}" ${index === visibleMonth.getMonth() ? "selected" : ""}>${escapeHtml(monthFormatter.format(new Date(2020, index, 1)))}</option>`).join("");
}

export function renderCalendarYearOptions(visibleMonth: Date): string {
  return Array.from({ length: 5 }, (_, index) => visibleMonth.getFullYear() - 2 + index)
    .map((year) => `<option value="${year}" ${year === visibleMonth.getFullYear() ? "selected" : ""}>${year}</option>`)
    .join("");
}

export function renderCalendarCells({ visibleMonth, today, selectedDate, availabilityDays, locale }: BookingCalendarCellsInput): string[] {
  const firstDay = new Date(visibleMonth.getFullYear(), visibleMonth.getMonth(), 1);
  const offset = (firstDay.getDay() + 6) % 7;
  const cells: string[] = [];
  for (let index = 0; index < 42; index += 1) {
    const date = new Date(visibleMonth.getFullYear(), visibleMonth.getMonth(), 1 - offset + index);
    const value = localDateValue(date);
    const inMonth = date.getMonth() === visibleMonth.getMonth();
    const past = value < today;
    const knownUnavailable = inMonth && availabilityDays.has(value) && availabilityDays.get(value) === 0;
    const disabled = !inMonth || past || knownUnavailable;
    const count = availabilityDays.get(value);
    const classes = ["calendar-day", inMonth ? "" : "outside", past ? "past" : "", knownUnavailable ? "unavailable" : "", value === selectedDate ? "selected" : "", value === today ? "today" : ""].filter(Boolean).join(" ");
    cells.push(`<button type="button" class="${classes}" data-calendar-date="${value}" ${disabled ? "disabled" : ""} aria-label="${escapeHtml(new Intl.DateTimeFormat(locale, { dateStyle: "full" }).format(date))}"${value === selectedDate ? " aria-pressed=\"true\"" : ""}><span>${date.getDate()}</span><small>${count && count > 0 ? count : ""}</small></button>`);
  }
  return cells;
}
